import { nextTick } from 'vue';
import { CONTROL_BAR_UPPER_CONTAINER_ID } from '@/enums/html-ids';

export async function scrollToChart() {
  await nextTick();

  const controlBarUpperContainerElement = document.getElementById(CONTROL_BAR_UPPER_CONTAINER_ID);

  if (!controlBarUpperContainerElement) {
    return;
  }

  const chartTop = controlBarUpperContainerElement.getBoundingClientRect().top;

  window.scrollBy({
    top: chartTop,
    behavior: 'smooth'
  });
}
